import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import AppRoutes from './routes/Routes';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Helmet, HelmetProvider } from 'react-helmet-async';


const ScrollToTop = () => {
  const { pathname } = useLocation();
  // const navigate = useNavigate()
  
  useEffect(() => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };

function App() {
  
  return (
    <>
    <ToastContainer />
    <HelmetProvider>
      <Helmet>
        <title>Bench Track</title>
        <meta name="description" content="Bench Track" />
      </Helmet>
      <Router>
        <ScrollToTop/>
        <AppRoutes/>
      </Router>
    </HelmetProvider>
    </>
  );
}
export default App;
